const AddOn = () => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.0025 18.664V6.40649M5.87376 12.5352H18.1313M21.5 12.5352C21.4927 15.0525 20.4895 17.4647 18.7095 19.2447C16.9295 21.0247 14.5173 22.028 12 22.0352C9.48267 22.028 7.07053 21.0247 5.2905 19.2447C3.51048 17.4647 2.50726 15.0525 2.5 12.5352C2.50726 10.0179 3.51048 7.60574 5.2905 5.82572C7.07053 4.04569 9.48267 3.04247 12 3.03522H21.5V12.5352Z"
        stroke="white"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
};
export default AddOn;
